import React, {Component} from 'react';
import {FlexGrid, FlexGridItem} from 'baseui/flex-grid';
import { StyledLink } from 'baseui/link';
import { SUPPORT, PRIVACY_POLICY } from '../Routes';

class Footer extends Component {

    render = () => {
        return <FlexGrid flexGridRowGap="scale800" backgroundColor={'primaryB'} style={{padding: '20px'}}>
            <FlexGridItem>
                <StyledLink href={SUPPORT}>Contact us</StyledLink>
                <div style={{width: '50px', display: 'inline-block'}}></div>
                <StyledLink href={PRIVACY_POLICY}>Policy</StyledLink>
            </FlexGridItem>
        </FlexGrid>
    };
}

export default Footer;